import { Button, Modal, message } from 'antd';
import React, { useState } from 'react';
import DataProductBuilderForm from './DataProductBuilderForm';
import { DataProductBuilderState } from './types';
import { useUpdateDataProductMutation } from '../../../../graphql/dataProduct.generated';
import { DataProduct } from '../../../../types.generated';
import { MODAL_BODY_STYLE, MODAL_WIDTH } from './CreateDataProductModal';
import { useTranslation } from '../../../../i18n/useTranslation';

type Props = {
    dataProduct: DataProduct;
    onClose: () => void;
    onUpdateDataProduct: (dataProduct: DataProduct) => void;
};

export default function EditDataProductModal({ dataProduct, onUpdateDataProduct, onClose }: Props) {
    const { t } = useTranslation();
    const [builderState, updateBuilderState] = useState<DataProductBuilderState>({
        name: dataProduct.properties?.name || '',
        description: dataProduct.properties?.description || '',
    });
    const [updateDataProductMutation] = useUpdateDataProductMutation();

    function updateDataProduct() {
        console.log(builderState.description || undefined, builderState.name, 'builderState.description....');
        updateDataProductMutation({
            variables: {
                urn: dataProduct.urn,
                input: {
                    name: builderState.name.trim(),
                    description: builderState.description || '',
                },
            },
        })
            .then(({ data, errors }) => {
                if (!errors) {
                    message.success(t('Updated data product!'));
                    if (data?.updateDataProduct) {
                        onUpdateDataProduct(data.updateDataProduct as DataProduct);
                    }
                    onClose();
                }
            })
            .catch((e) => {
                onClose();
                message.destroy();
                message.error({ content: `Failed to update Data Product. \n ${e.message || ''}`, duration: 3 });
            });
    }

    return (
        <Modal
            title={`${t('Update')} ${dataProduct.properties?.name || t('Data Product')}`}
            onCancel={onClose}
            style={MODAL_BODY_STYLE}
            width={MODAL_WIDTH}
            centered
            open
            footer={
                <>
                    <Button onClick={onClose} type="text">
                        {t('Cancel')}
                    </Button>
                    <Button onClick={updateDataProduct} disabled={!builderState.name}>
                        {t('Update')}
                    </Button>
                </>
            }
        >
            <DataProductBuilderForm builderState={builderState} updateBuilderState={updateBuilderState} />
        </Modal>
    );
}
